import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Card } from "flowbite-react";

const QueryLoading = () => {
  return (
    <Card>
      <div className="mx-auto text-center my-10">
        <div className="max-w-xl -mt-10">
          <DotLottieReact
            src="https://lottie.host/7952bec9-5471-489d-98cc-56d9dfa19fd5/mjdWfj8Rpv.lottie"
            loop
            autoplay
          />
        </div>
        <div className="font-semibold color-primary -mt-10 ">Carregando consulta...</div>
      </div>
    </Card>
  );
};

export default QueryLoading;
